import React from "react";
import App from "next/app";
import * as Sentry from "@sentry/browser";
import { HandleGoogleBotErrors, RedirectToHome } from "../lib/legacy";
import getConfig from "next/config";
import Router from "next/router";
import NProgress from "nprogress";
import DisclaimerPeru from "../shared-components/Components/Disclaimers/DisclaimerPeru/web";

import Cookies from "universal-cookie";
import { BugReport } from "../src/Components/BugReport/web";

import "../shared-components/Styles/GlobalStyles.less";

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

const { sentryDNS, NODE_ENV, APP_NAME, APP_VERSION } = getConfig().publicRuntimeConfig;

class FeedbackTransport extends Sentry.Transports.XHRTransport {
	async sendEvent(event) {
		let isBot = navigator && /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)
		if(isBot){
			HandleGoogleBotErrors(event)
			return null;
		}else{
			return super.sendEvent(event).finally(e => RedirectToHome(e));
		}
	}
}

if (typeof window !== "undefined" && sentryDNS) {
	Sentry.init({
		dsn: sentryDNS,
		debug: NODE_ENV === "development",
		environment: NODE_ENV,
		release: APP_NAME + " " + APP_VERSION,
		ignoreErrors: ["ResizeObserver loop limit exceeded"],
		beforeSend: (e, h) => {
			// use this function if we want to discard some errors (just returning null instead of event e)

			// si no hay internet no manda error
			if (typeof window != "undefined" && !window.navigator.onLine) return null;
			const error = h.originalException;
			// no manda el error de typeerror cancelled

			if (
				error &&
				error.message &&
				error.message.match(/(typeError|network error):\s*(cancelado|cancelled)/i)
			) {
				return null;
			}

			return e;
		},
		transport: FeedbackTransport,
	});
}

class MyApp extends App {
	componentDidCatch(error, errorInfo) {
		Sentry.withScope(scope => {
			Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]));
			Sentry.captureException(error);
		});
		super.componentDidCatch(error, errorInfo);
	}

	componentDidMount() {
		// scroll top when page changes
		Router.events.on("routeChangeComplete", () => window.scroll(0, 0));
		// end
		if (NODE_ENV === "production") {
			const coockies = new Cookies();
			if (!coockies.get("stick_ic2")) {
				coockies.set("stick_ic2", 1);
			}
		}
	}

	render() {
		const { Component, pageProps } = this.props;
		return (
			<React.Fragment>
				<DisclaimerPeru data={pageProps} />
				<Component {...pageProps} />
				<BugReport />
			</React.Fragment>
		);
	}
}


export default MyApp;